import { Button } from '@heroui/react';
import { MdCheckCircle } from 'react-icons/md';
import { useTimer } from 'hooks';
import { SurveyLayout } from '@/components';

interface SuccessMessageProps {
    handleReset: () => void;
    surveyLimitReached?: boolean;
    nEncuesta?: number;
}

const SuccessMessageComponent = ({ handleReset, surveyLimitReached, nEncuesta }: SuccessMessageProps) => {
    const noop = () => { /* no-op */ };
    const { progress } = useTimer(surveyLimitReached ? 0 : 10, surveyLimitReached ? noop : handleReset);

    return (
        <SurveyLayout>
            <div className="flex flex-col items-center justify-center pt-2.5 animate-fade-in">
                <MdCheckCircle className="text-[150px] text-[#488b70]" />
                <p className="py-4 text-center text-lg font-medium">
                    {nEncuesta === 8 
                        ? 'Gracias por compartir su experiencia. Esperamos poder atenderle nuevamente en el futuro.' 
                        : '¡Muchas gracias por contestar nuestra encuesta!'
                    }
                </p>
                {/* <p className="text-center text-sm text-[#757575]">
                    Gracias por compartir su experiencia y esperamos poder atenderle nuevamente en el futuro  
                </p> */}
                {!surveyLimitReached && (
                    <>
                        <p className="pb-2.5 text-sm text-[#757575]">{`Redireccionando en ${progress}`}</p>
                        <Button color="primary" onPress={handleReset}>
                            CONTESTAR DE NUEVO
                        </Button>
                    </>
                )}
            </div>
        </SurveyLayout>
    );
};

export default SuccessMessageComponent;
